<template>
  <div class="ucenter_smrz">
    <div class="ucenter_smrz_div">
      <div class="ucenter_smrz_butt_s">
        <div class="ucenter_smrz_butt_s_div">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item
              ><a @click="qiehuanrzon('个人认证')"
                >个人认证</a
              ></el-breadcrumb-item
            >
            <el-breadcrumb-item
              ><a @click="qiehuanrzon('企业认证')"
                >企业认证</a
              ></el-breadcrumb-item
            >
            <el-breadcrumb-item
              ><a @click="qiehuanrzon('技术认证')"
                >技术认证</a
              ></el-breadcrumb-item
            >
            <div></div>
          </el-breadcrumb>
        </div>
      </div>

      <div class="ucenter_smrz_main_s" v-if="qiehuanrz == '个人认证'">
        <div class="ucenter_smrz_main_s_div">
          <div class="ucenter_smrz_main_s_div_1">
            <i class="i_yuan">1</i>
            <div v-if="lansei == 'txjbxx'" class="lan_sei">填写基本信息</div>
            <div v-else>填写基本信息</div>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="ucenter_smrz_main_s_div_2">
            <i class="i_yuan">2</i>
            <div v-if="lansei == 'jyrz'" class="lan_sei">校验认证</div>
            <div v-else>校验认证</div>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="ucenter_smrz_main_s_div_3">
            <i class="i_yuan">3</i>
            <div v-if="lansei == 'rzcg'" class="lan_sei">
              认证完成，免费试用
            </div>
            <div v-else>认证完成，免费试用</div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div>
          <div class="H_text_img">
            <img
              src="http://apiupss.ppfly.top/images/p_1.svg"
              alt=""
            />
            <div>信息认证</div>
          </div>
          <div class="form_main" v-if="lansei == 'txjbxx'">
            <el-form
              :model="form"
              :rules="rules"
              ref="formRef"
              label-width="120px"
            >
              <el-form-item label="真实姓名" prop="realName">
                <el-input
                  v-model="form.real_name"
                  placeholder="请输入真实姓名"
                />
              </el-form-item>

              <el-form-item label="身份证号" prop="idNumber">
                <el-input
                  v-model="form.id_card"
                  placeholder="请输入身份证号"
                  @blur="validateIdCard"
                />
                <el-alert
                  v-if="idCardError"
                  title="身份证号格式不正确"
                  type="error"
                  show-icon
                />
              </el-form-item>

              <el-form-item label="使用场景" prop="usageScenario">
                <el-select
                  v-model="form.usage_scenario"
                  placeholder="请选择使用场景"
                >
                  <el-option label="个人" value="个人" />
                  <el-option label="企业" value="企业" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>

              <el-form-item label="代理类型" prop="proxyType">
                <div class="select_input">
                  <el-select
                    v-model="form.agent_type"
                    placeholder="请选择代理类型"
                  >
                    <el-option label="静态代理" value="静态代理" />
                    <el-option label="动态代理" value="动态代理" />
                  </el-select>
                  <el-input
                    class="select_input_input"
                    v-model="form.myyl"
                    placeholder="请输入每月用量"
                  />
                </div>
              </el-form-item>

              <el-form-item label="使用国家">
                <el-input
                  v-model="form.country_ofUse"
                  placeholder="请输入使用国家"
                />
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="handleSubmit">提交</el-button>
              </el-form-item>
            </el-form>
          </div>

          <div class="form_main" v-show="lansei == 'jyrz'">
            <div class="srrz_div">
              <div>
                <div>扫面下方二维码</div>
                <div>进行认证</div>
                <div class="canvas_div">
                  <canvas ref="qrcodeCanvas"></canvas>
                  <p v-if="countdown > 0">请在: {{ countdown }} 秒内，完成实名</p>
                </div>
              </div>
            </div>
          </div>

          <div class="form_main" v-show="lansei == 'rzcg'">
            <div class="form_kay">
              <div class="form_kay_h1">恭喜您实名认证成功</div>
              <div class="form_kay_text">
                <div><span>用户名</span><span>{{Cardlist.username}}</span></div>
                <div><span>姓名</span><span>{{Cardlist.RealName}}</span></div>
                <div><span>身份证</span><span>{{Cardlist.IdCard}}</span></div>
                <div class="form_kay_div">
                  <div>联系客服，领取您的免费测试流量</div>
                  <div>
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                  <div>
                    若您是企业用户，请联系客服升级为企业认证，再领取1G测试流量
                  </div>
                  <div>
                    <div
                      class="form_kay_div_div_butt"
                      @click="openWeChatChat()"
                    >
                      联系客服
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="H_text_img">
            <img
              src="http://apiupss.ppfly.top/images/tip.png"
              alt=""
            />
            <div>小贴士</div>
          </div>
          <div class="xts_main">
            <div>1、同 1 个身份信息可实名最多 1 个奇迹ip账号</div>
            <div>
              2、企业账户请避免使用个人实名，以免企业人员变动或交接引起不必要的纠纷
            </div>
            <div>
              3、完成实名认证后，免费试用额度立即到账，可用于使用动态住宅、长效ISP、动态数据中心代理，了解更多
            </div>
          </div>
        </div>
      </div>

      <div class="ucenter_smrz_main_s" v-if="qiehuanrz == '企业认证'">
        <div class="ucenter_smrz_main_s_div">
          <div class="ucenter_smrz_main_s_div_1">
            <i class="i_yuan">1</i>
            <div>填写基本信息</div>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="ucenter_smrz_main_s_div_2">
            <i class="i_yuan">2</i>
            <div>校验认证</div>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="ucenter_smrz_main_s_div_3">
            <i class="i_yuan">3</i>
            <div>认证完成，免费试用</div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div>
          <div class="H_text_img">
            <img
              src="http://apiupss.ppfly.top/images/p_1.svg"
              alt=""
            />
            <div>信息认证</div>
          </div>
          <div class="form_main">
            <el-form
              :model="form"
              :rules="rules"
              ref="formRef"
              label-width="120px"
            >
              <el-form-item label="真实姓名" prop="realName">
                <el-input
                  v-model="form.real_name"
                  placeholder="请输入真实姓名"
                />
              </el-form-item>

              <el-form-item label="身份证号" prop="idNumber">
                <el-input
                  v-model="form.id_card"
                  placeholder="请输入身份证号"
                  @blur="validateIdCard"
                />
                <el-alert
                  v-if="idCardError"
                  title="身份证号格式不正确"
                  type="error"
                  show-icon
                />
              </el-form-item>

              <el-form-item label="使用场景" prop="usageScenario">
                <el-select
                  v-model="form.usage_scenario"
                  placeholder="请选择使用场景"
                >
                  <el-option label="个人" value="个人" />
                  <el-option label="企业" value="企业" />
                  <el-option label="其他" value="其他" />
                </el-select>
              </el-form-item>

              <el-form-item label="代理类型" prop="proxyType">
                <div class="select_input">
                  <el-select
                    v-model="form.agent_type"
                    placeholder="请选择代理类型"
                  >
                    <el-option label="静态代理" value="静态代理" />
                    <el-option label="动态代理" value="动态代理" />
                  </el-select>
                  <el-input
                    class="select_input_input"
                    v-model="form.myyl"
                    placeholder="请输入每月用量"
                  />
                </div>
              </el-form-item>

              <el-form-item label="使用国家">
                <el-input
                  v-model="form.country_ofUse"
                  placeholder="请输入使用国家"
                />
              </el-form-item>

              <!-- 添加文件上传 -->
              <el-form-item label="上传文件" prop="fileUpload">
                <el-upload
                  class="upload-demo"
                  drag
                  action="http://192.168.2.3:8088/user/qy_auth/add"
                  :headers="uploadHeaders"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                  :file-list="fileList"
                  :on-remove="handleRemove"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    只能上传jpg/png文件，且不超过500kb
                  </div>
                </el-upload>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="handleSubmits"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div>
          <div class="H_text_img">
            <img
              src="http://apiupss.ppfly.top/images/tip.png"
              alt=""
            />
            <div>小贴士</div>
          </div>
          <div class="xts_main">
            <div>1、同 1 个身份信息可实名最多 1 个奇迹ip账号</div>
            <div>
              2、企业账户请避免使用个人实名，以免企业人员变动或交接引起不必要的纠纷
            </div>
            <div>
              3、完成实名认证后，免费试用额度立即到账，可用于使用动态住宅、长效ISP、动态数据中心代理，了解更多
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/requset/api";
import QRious from "qrious";
export default {
  name: "ucenter_smrz",
  data() {
    return {
      Cardlist:{
        IdCard:'',
        RealName:'',
        username:'',
      },
      idCardError: false,
      countdown: 50, // 倒计时初始值（50秒）
      authInterval:null,
      // renzhengtype:"",  txjbxx
      lansei: "txjbxx",
      erwrzid: "",
      qiehuanrz: "个人认证",
      grrz: true,
      qyrz: false,
      jsrz: false,
      active: 0,
      form: {
        user_id: "",
        real_name: "",
        id_card: "",
        usage_scenario: "",
        agent_type: "",
        country_ofUse: "",
        myyl: "",
      },
      token: "",
      rules: {
        real_name: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        id_card: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        usage_scenario: [
          { required: true, message: "请选择使用场景", trigger: "change" },
        ],
        agent_type: [
          { required: true, message: "请选择代理类型", trigger: "change" },
        ],
        country_ofUse: [
          { required: true, message: "请输入国家", trigger: "change" },
        ],
      },
      fileList: [], // 用于存储上传的文件列表
    };
  },
  computed: {
    uploadHeaders() {
      const token = this.$cookies.get("userdata");
      // this.username = token.data.user_data.Nickname;
      this.token = token.data.token;
      return {
        Authorization: `${this.token}`, // 使用 Bearer 认证方式
      };
    },
  },
  methods: {
    openWeChatChat() {
    },
    validateIdCard() {
      const idCardRegex = /^(?:\d{15}|\d{17}[\dXx])$/;
      this.idCardError = !idCardRegex.test(this.form.id_card);
    },
    handleSubmits() {

      // 提交表单的逻辑
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 这里可以添加提交表单的逻辑
        } else {
          return false;
        }
      });
    },
    handleUploadSuccess(response, file) {
      // 上传成功的回调
      this.fileList.push(file);
    },
    beforeUpload(file) {
      // 上传前的检查
      const isAllowedType = [
        "image/jpeg",
        "image/png",
        "image/svg+xml",
        "image/webp",
      ].includes(file.type);
      const isLt500K = file.size / 1024 < 25500;

      if (!isAllowedType) {
        this.$message.error("上传文件只能是 JPG、PNG 或 SVG 格式!");
      }
      if (!isLt500K) {
        this.$message.error("上传文件大小不能超过 500KB!");
      }
      return isAllowedType && isLt500K;
    },
    handleRemove(file, fileList) {
      // 删除文件的回调
      this.fileList = fileList;
    },

    qiehuanrzon(name) {
      this.qiehuanrz = name;
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    handleSubmit() {
      const token = this.$cookies.get("userdata");
      this.token = token.data.token;
      this.form.user_id = token.data.user_data.id;

      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 在这里处理表单提交
          // console.log("表单数据:", this.form);
          // 你可以在这里添加进一步的处理逻辑，例如发送请求到服务器
          api
            .auth(
              {
                user_id: this.form.user_id,
                real_name: this.form.real_name,
                id_card: this.form.id_card,
                usage_scenario: this.form.usage_scenario,
                agent_type: this.form.agent_type,
                country_ofUse: this.form.country_ofUse,
              },
              token.data.token
            )
            .then((res) => {
              this.erwrzid = res.data.data;
              const orderNo = this.erwrzid.split("orderNo=")[1].split("&")[0];
              this.$cookies.set("orderNo=", orderNo);
              if (res.data.error_code == 0) {
                this.generateQRCode(this.erwrzid);
                this.lansei = "jyrz";
                this.$message.success(res.data.message);
                this.authInterval = setInterval(() => {
                  this.getauth(); // 每 2 秒调用一次
                }, 5000);

                // 开始倒计时
                const countdownInterval = setInterval(() => {
                  if (this.countdown > 0) {
                    this.countdown--; // 每秒减少倒计时
                  } else {
                    clearInterval(countdownInterval); // 清除倒计时
                    this.stopAuthPolling(); // 停止调用
                  }
                }, 1000);


              } else if (res.data.error_code == 2010) {
                this.$message.success(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err, "走失败");
            });
        } else {
          this.$message.error("请填写必填项！");
          return false;
        }
      });
    },

    stopAuthPolling() {
      // 停止定时调用
      this.lansei = "txjbxx";
      this.countdown = 50
      if (this.authInterval) {
        clearInterval(this.authInterval);
        this.authInterval = null; // 清空定时器
      }
    },
    stopAuthPollingrzcg() {
      // 停止定时调用
      this.lansei = "rzcg";
      if (this.authInterval) {
        clearInterval(this.authInterval);
        this.authInterval = null; // 清空定时器
      }
    },
    getauth() {
      const token = this.$cookies.get("userdata");
      api
        .getauth({}, token.data.token)
        .then((res) => {
          if (res.data.data.Status == "1") {
            this.Cardlist.IdCard = res.data.data.IdCard
            this.Cardlist.RealName = res.data.data.RealName
            this.Cardlist.username = token.data.user_data.Nickname
            clearInterval(this.authInterval);
            // console.log('已实名');
            this.$message.success("已实名");
            this.lansei = "rzcg";
            clearInterval(countdownInterval); // 清除倒计时
            this.stopAuthPollingrzcg()
          }
        })
        .catch((err) => {
          console.log(err, "走失败");
        });
    },

    generateQRCode(url) {
      const qr = new QRious({
        element: this.$refs.qrcodeCanvas,
        value: url,
        size: 200, // 二维码的大小
      });
    },
  },
  created() {
    // this.getauth();
    // token
    // const token = this.$cookies.get("userdata");
    // this.username = token.data.user_data.Nickname;
  },
  mounted() {},
};
</script>

<style>
.canvas_div {
  background-color: #eaebee;
  padding: 20px;
  border-radius: 30px;
  margin-top: 10px;
}
.lan_sei {
  color: #2b43c9;
}
.div_split {
  margin: 0 20px 0 0;
  width: 1px;
  height: 27px;
  background-color: #dcdfe6;
}
.ucenter_smrz {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.ucenter_smrz_butt_s {
  /* display: flex;
  justify-content: left;
  width: 100%;
  padding: 20px 0 20px 20px;
  border-radius: 25px;
  background-color: #141313; */

  width: 100%;
  padding: 20px 0 20px 0;
  border-radius: 25px;
  background-color: #edf3fc;
}
.ucenter_smrz_butt_s_div {
  margin-left: 20px;
}

.ucenter_smrz_div {
  width: 100%;
  padding: 10px;
}

.ucenter_smrz_main_s {
  width: 100%;
  padding: 20px 0 20px 0;
  border-radius: 25px;
  background-color: #edf3fc;
  margin-top: 20px;
}
.ucenter_smrz_main_s_div {
  width: 500px;
  font-size: 14px;
  font-weight: 400;
  color: #737791;
  /* margin-left: 7px; */
  margin-right: 7px;
  display: flex;
  justify-content: center;
}
.ucenter_smrz_main_s_div > div {
  /* background-color: #737791; */
  /* width: 500px; */
  display: flex;
  justify-content: space-around;
}
.i_yuan {
  /* padding: 10px; */
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #000000;
  margin-right: 8px;
  margin-left: 15px;
  margin-top: 2px;
}
.el-icon-arrow-right {
  font-size: 19px;
  margin-top: 1px;
}
.form_main {
  width: 300px;
  margin-left: 100px;
}
.H_text_img {
  display: flex;
  justify-content: left;
  margin: 30px;
}
.H_text_img > img {
  margin-right: 10px;
  /* margin-top: 5px; */
}
.ucenter_smrz_main_s_div_1 {
}
.ucenter_smrz_main_s_div_2 {
}
.ucenter_smrz_main_s_div_3 {
}
.select_input {
  position: relative;
}
.select_input_input {
  position: absolute;
  width: 135px;
  margin-left: 10px;
}
.xts_main > div {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #444a6d;
  line-height: 22px;
  margin-bottom: 4px;
  text-align: left;
  margin-left: 80px;
}
.form_kay {
  width: 600px;
  border: 1px solid #919090;
  border-radius: 10px;
  overflow: hidden;
}
.form_kay_h1 {
  background-color: #2b43c9;
  color: #edf3fc;
  font-size: 16px;
  padding: 10px 0 10px 10px;
  text-align: left;
}
.form_kay_text {
  padding: 10px;
}
.form_kay_text > div {
  display: flex;
  justify-content: left;
  margin-bottom: 20px;
  padding-bottom: 5px;
  font-size: 15px;
}
.form_kay_text > div > span:nth-child(1) {
  width: 201px;
  height: 37px;
  font-size: 14px;
  font-weight: 400;
  line-height: 37px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  color: #444a6d;
  display: flex;
  margin: 0 auto;
  padding-left: 50px;
}
.form_kay_text > div > span:nth-child(2) {
  width: 401px;
  height: 37px;
  font-size: 14px;
  font-weight: 400;
  line-height: 37px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  color: #444a6d;
  display: flex;
  margin: 0 auto;
}
.form_kay_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: rgba(5, 21, 238, 0.07);
  width: 300px;
  margin: 0 auto;
  padding: 30px;
  border-radius: 10px;
}
.form_kay_div > div:nth-child(4) {
  display: flex;
  justify-content: center;
}
.form_kay_div_div_butt {
  background-color: #2b43c9;
  color: #edf3fc;
  width: 100px;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  margin: 20px 0 20px 0;
  cursor: pointer;
}
.el-icon-caret-bottom {
  font-size: 30px;
  color: #2b43c9;
  margin: 20px 0 20px 0;
}
</style>
